export default __webpack_public_path__ + "static/media/3.2c254eb4.png";